import { Modal } from 'react-responsive-modal';
import PayOutChartPercentageProgram from 'components/PayOutChartPctProgram';

const PayOutChartPercentageProgramPopup = ({open, close}) => {
   

    return (
        <>
            <Modal classNames={{ overlay: 'contact-support-overlay', modal: 'payout-chat-modal', }}
                open={open}
                onClose={close}
                center>
                <PayOutChartPercentageProgram />
            </Modal>
        </>
    )
}

export default PayOutChartPercentageProgramPopup;